module.exports = __webpack_public_path__ + "static/media/autobook.2e18dc4a.svg";